import classNames from 'classnames';
import { forwardRef, useId, type CSSProperties } from 'react';
import styles from './ToggleSwitch.module.css';
import type { ToggleSwitchProps } from './types';
const ToggleSwitch = forwardRef<HTMLInputElement, ToggleSwitchProps>(function ToggleSwitch({
  'id': id_,
  name,
  'error': _error = false,
  'classNames': externalStyles,
  'aria-disabled': ariaDisabled_,
  'aria-required': ariaRequired_,
  children,
  required,
  checked,
  disabled_,
  disabled,
  size = 'small',
  labelPosition = 'right',
  labelForOn,
  labelForOff,
  trackScale = 1,
  ...props
}: ToggleSwitchProps, ref) {
  const generatedId = useId();
  const id = id_ || name || generatedId;
  const ariaDisabled = ariaDisabled_ || disabled || disabled_;
  return <label style={{
    '--track-scale': trackScale
  } as CSSProperties} className={classNames(styles.toggle, externalStyles?.label)} htmlFor={id}>
      {labelPosition === 'left' ? <div className={classNames(styles.labelText, externalStyles?.labelText, {
      [styles.disabledLabel!]: ariaDisabled
    })}>
          {children}
        </div> : null}
      <input tabIndex={0} {...props} role="switch" type="checkbox" className={classNames(styles.toggleInput, styles[size])} id={id} ref={ref} name={name} required={required} disabled={disabled_} aria-disabled={ariaDisabled} aria-required={required} aria-checked={checked} />
      <span className={classNames(styles.toggleTrack, {
      [styles.toggleTrackNoLabel!]: !(labelForOn && labelForOff),
      [styles.toggleTrackWithLabel!]: labelForOn && labelForOff
    })}>
        {labelForOn && labelForOff ? <span className={styles.onLabel} aria-hidden>
            {labelForOn}
          </span> : null}
        <span className={styles.toggleIndicator} />
        {labelForOn && labelForOff ? <span className={styles.offLabel} aria-hidden>
            {labelForOff}
          </span> : null}
      </span>
      {labelPosition === 'right' ? <div className={classNames(styles.labelText, externalStyles?.labelText, {
      [styles.disabledLabel!]: ariaDisabled
    })}>
          {children}
        </div> : null}
    </label>;
});
export default ToggleSwitch;